module.exports = __webpack_public_path__ + "img/购买失败.11027bec.svg";